import { Outlet } from 'react-router-dom';
import { ScrollToTop } from './ScrollToTop';
import { BuildVersion } from './BuildVersion';

/**
 * RootLayout — обёртка для всех маршрутов в react-router data router.
 * Renders `<ScrollToTop />` (P-047 scroll restoration) и `<Outlet />` —
 * выбранный child route.
 *
 * Используется в `router.tsx`:
 * ```ts
 * createBrowserRouter([{
 *   element: <RootLayout />,
 *   children: [
 *     { path: '/', element: <App /> },
 *     // ... остальные 26 routes
 *   ],
 * }]);
 * ```
 *
 * RootLayout почти пустой layout-shell — каждый child route рендерит свой
 * `<main>` + `<Header/>` + `<BottomBar/>` (P-046). RootLayout существует как
 * точка монтирования cross-route эффектов и оверлеев (сейчас — `ScrollToTop`
 * + `BuildVersion`; будущее — global modals, auth-listener и т.п.).
 *
 * `BuildVersion` (Задача A) — fixed-оверлей штампа версии, монтируется один раз
 * поверх всех экранов; не часть per-screen layout shell.
 */
export function RootLayout() {
  return (
    <>
      <ScrollToTop />
      <Outlet />
      <BuildVersion />
    </>
  );
}
